import { render, staticRenderFns } from "./medicalNews.vue?vue&type=template&id=88ff3c28&scoped=true&"
import script from "./medicalNews.vue?vue&type=script&lang=js&"
export * from "./medicalNews.vue?vue&type=script&lang=js&"
import style0 from "./medicalNews.vue?vue&type=style&index=0&id=88ff3c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ff3c28",
  null
  
)

export default component.exports